import { weekdayName } from '../../i18n/calendarLabels';
import React from "react";
import PropTypes from "prop-types";
import { useHistory, useLocation } from "react-router-dom";
import { displayDate } from "../common/datePresentation";
import { findDayOfWeek, getClassTypeName } from "../common/Helpers";
import { DEFAULT_LESSON_TYPES_SETTING } from "../common/lessonTypes";
import {
  buildAttendanceRoute,
  getClassIdFromLessonId,
  getLessonIndexFromId,
} from "./attendanceLessonSelectors";
import { isAttendanceChecked } from "./lessonAttendanceStatus";
import { useTranslation } from 'react-i18next';

const getLessonDetails = lesson => (
  lesson.lessonRegister
    ? {
      ...(lesson.defaultLessonDetails || {}),
      ...(lesson.lessonRegister.lessonDetails || {}),
    }
    : lesson.defaultLessonDetails
);

const getTeacherName = (teacherId, teachers) => {
  const teacher = teachers.find(item => item.id === teacherId);
  return teacher ? `${teacher.firstName || ""} ${teacher.lastName || ""}`.trim() : teacherId;
};

function LessonsList({
  scheduledLessons,
  teachers,
  classTypes,
  lessonTypes,
}) {
  const { t: tr , i18n } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const openLesson = (lesson) => {
    history.push(buildAttendanceRoute(
      lesson.schoolClassId || getClassIdFromLessonId(lesson.id),
      getLessonIndexFromId(lesson.id),
      location.search,
    ));
  };

  const handleKeyDown = (event, lesson) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      openLesson(lesson);
    }
  };
  const getLessonTypeName = classTypeId => {
    const classType = classTypes.find(type => type.id === classTypeId);
    return classType ? classType.name : getClassTypeName(classTypeId, lessonTypes);
  };

  return (
    <div>
      <div className="row d-flex align-items-center mx-0 my-3">
        <h2 className="manage-title pb-0">{tr("manage:scheduledClasses_242")}</h2>
        <div className="col-block col-md-auto ml-md-auto px-0" />
      </div>

      <div>
        <div className="row table-header manage-table-title text-center mx-0 d-flex align-items-center">
          <div className="col-12">
            <div className="row d-flex align-items-center">
              <div className="col-sm-2 pl-sm-4 table-cell">{tr("manage:date_8")}</div>
              <div className="col-sm-2 table-cell">{tr("manage:dayOfTheWeek_243")}</div>
              <div className="col-sm-2 table-cell">{tr("calendar:time")}</div>
              <div className="col-sm-3 table-cell">{tr("manage:type_129")}</div>
              <div className="col-sm-3 table-cell">{tr("manage:teacher_226")}</div>
            </div>
          </div>
        </div>
        {scheduledLessons.map((lesson) => {
          const details = getLessonDetails(lesson);
          const weekday = findDayOfWeek(details.dayOfWeek);
          const attendanceClass = isAttendanceChecked(lesson) ? "lesson-attendance-row-checked" : "";

          return (
            <div
              key={lesson.id}
              role="button"
              tabIndex={0}
              className={`row d-flex align-items-center mx-0 table-row lesson-attendance-row ${attendanceClass}`}
              onClick={() => openLesson(lesson)}
              onKeyDown={event => handleKeyDown(event, lesson)}
            >
              <div className="col-12">
                <div className="row d-flex align-items-center">
                  <div className="col-sm-2 pl-sm-4 table-cell">{displayDate(details.date, i18n.language)}</div>
                  <div className="col-sm-2 table-cell">{weekday ? weekdayName(weekday.id, i18n.language) : details.dayOfWeek}</div>
                  <div className="col-sm-2 table-cell">{details.startTime}</div>
                  <div className="col-sm-3 table-cell">{getLessonTypeName(details.classTypeId)}</div>
                  <div className="col-sm-3 table-cell">{getTeacherName(details.teacherId, teachers)}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

LessonsList.propTypes = {
  scheduledLessons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      schoolClassId: PropTypes.string,
      defaultLessonDetails: PropTypes.object.isRequired,
      lessonRegister: PropTypes.object,
    }),
  ).isRequired,
  teachers: PropTypes.array.isRequired,
  classTypes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  })),
  lessonTypes: PropTypes.shape({
    id: PropTypes.string.isRequired,
    types: PropTypes.array.isRequired,
  }),
};

LessonsList.defaultProps = {
  classTypes: [],
  lessonTypes: DEFAULT_LESSON_TYPES_SETTING,
};

export default LessonsList;
